import { computed, inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { exchangeRatesActions, exchangeRatesFeature } from '@store/exchange-rates';
import { CookieService } from '@core/services';
import {
  EXCHANGE_RATES_COOKIE_NAME,
  ExchangeRatesCoins,
} from '@data/config';

@Injectable({ providedIn: 'root' })
export class ExchangeRatesFacade {
  private readonly cookieService = inject(CookieService);

  private readonly store = inject(Store);

  readonly lee = computed(() => {
    const cookieValue = this.getValueFromCookie('lee');
    const storeValue = this.store.selectSignal(exchangeRatesFeature.selectLee)();
    return storeValue ?? cookieValue;
  });

  readonly cheelee = computed(() => {
    const cookieValue = this.getValueFromCookie('cheelee');
    const storeValue = this.store.selectSignal(exchangeRatesFeature.selectCheelee)();
    return storeValue ?? cookieValue;
  });

  getCurrencyPair(): void {
    return this.store.dispatch(exchangeRatesActions.getCurrencyPairsRequest());
  }

  private getValueFromCookie(coin: ExchangeRatesCoins): number | undefined {
    const cookie = this.cookieService.get(EXCHANGE_RATES_COOKIE_NAME);

    try {
      const parsed = JSON.parse(cookie);
      if (Object.hasOwn(parsed, coin)) {
        return parsed[coin];
      }
      return undefined;
    } catch {
      return undefined;
    }
  }
}
